// extracted by mini-css-extract-plugin
export var calloutItem = "imageCallout-module--calloutItem--73ekP";
export var calloutItemFramed = "imageCallout-module--calloutItemFramed--es1fH";
export var frame = "imageCallout-module--frame--wHzhx";
export var imageRight = "imageCallout-module--imageRight--bt+Sz";
export var calloutItemGradientPad = "imageCallout-module--calloutItemGradientPad--cEMxD";
export var calloutItemGradient = "imageCallout-module--calloutItemGradient--SoeQs";
export var imgWrap = "imageCallout-module--imgWrap--g1LkT";
export var slideshowCover = "imageCallout-module--slideshowCover--xM05n";
export var imgRound = "imageCallout-module--imgRound--HHSBa";
export var textWrap = "imageCallout-module--textWrap--1KGtv";
export var buttonWrap = "imageCallout-module--buttonWrap---q+CZ";
export var imgWrapInner = "imageCallout-module--imgWrapInner--i-NWc";
export var slideUp = "imageCallout-module--slideUp--f0fvO";
export var slideUpLarge = "imageCallout-module--slideUpLarge--zIBhp";